import React, { useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import './UsersList.css';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";
import { Col, Container, Form, Row, Modal, Button } from "react-bootstrap"; // ✅ Added Modal & Button
import useAuth from "../../hooks/useAuth";
import { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

const ArthiksakhaListGurudakshinaInSthan = () => {

  const { Id, Name } = useParams();
  const [gurudakshinas, setGurudakshinas] = useState([]);
  const [gurudakshinaFinalizationStatus, setGurudakshinasFinalizationStatus] = useState([]);
  const [FinalSubmissionList, setFinalSubmissionList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const gurudakshinaPerPage = 50;
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [pranthNames, setPranthNames] = useState({});
  const [selectedSakha, setSelectedSakha] = useState("Vidyarthi Samyuktha");
  const [pranthList, setPranthList] = useState([]);
  const [sakhaList, setSakhaList] = useState([]);
  const { auth } = useAuth();

  const [proudaSubmitted, setProudaSubmitted] = useState(false);
  const [vidyarthiSamyukthaSubmitted, setVidyarthiSamyukthaSubmitted] = useState(false);
  const [vidyarthiTharunaSubmitted, setVidyarthiTharunaSubmitted] = useState(false);
  const [vyavasayiTharunaSubmitted, setVyavasayiTharunaSubmitted] = useState(false);

  const [sakhaSubmitted, setSakhaSubmitted] = useState("");

  const [errMsg, setErrMsg] = useState("");
  const [sucssMsg, setSucssMsg] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const errRef = useRef();

  // ✅ Modal state
  const [showFinalizeModal, setShowFinalizeModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const handleCloseModal = () => setShowFinalizeModal(false);
  const handleShowModal = async () => {
    try {
      const response = await fetchFinalSubmissionList(); // your API function
      setShowFinalizeModal(true); // Open modal after success
    } catch (error) {
      console.error("Failed to fetch finalize data:", error);
      // Optionally show error toast or alert here
    }
  };

  const ClickAddGurudakshina = () => {
    // Navigate to the GetFranchise component with franchiseId as a URL parameter
    navigate(`/arthikShakha/add/gurudakshina/${Id}/`);
  };
  const handleFinalize = () => {
    setShowFinalizeModal(false);    // Close first modal
    setShowSecondModal(true);       // Show second confirmation modal
  };

  const handleCloseSecondModal = () => setShowSecondModal(false);

  const fetchSakhaList = async () => {
    try {
      const res = await axiosPrivate.get('get-sakhas');
      setSakhaList(res.data);
    } catch (err) {
      console.error("Failed to fetch sakhas", err);
    }
  };

  useEffect(() => {
    fetchSakhaList();
  }, []);

  const fetchgurudakshina = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`list-gurudakshina?sthan_id=${Id}&sakha=${selectedSakha}`, {
        withCredentials: true,
      });
      const GurudakshinaList = response.data;
      setGurudakshinas(GurudakshinaList);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedSakha]);


  const fetchGurudakshinaFinalizationStatus = useCallback(async () => {
    setError(null);
    try {

      const response = await axiosPrivate.get(`gurudakshina-finalization-status?sthan_id=${Id}&sakha=${selectedSakha}`, {
        withCredentials: true,
      });
      setGurudakshinasFinalizationStatus(response.data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, selectedSakha]);


  const fetchFinalSubmissionList = useCallback(async () => {
    setError(null);
    try {
      const response = await axiosPrivate.get(`list-final-submissions?sthan_id=${Id}`, {
        withCredentials: true,
      });

      const data = response.data;
      setFinalSubmissionList(data);
      setLoading(false);

      data.forEach(item => {
        switch (item.sakha) {
          case "Prouda":
            setProudaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Samyuktha":
            setVidyarthiSamyukthaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vidyarthi Tharuna":
            setVidyarthiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          case "Vyavasayi Tharuna":
            setVyavasayiTharunaSubmitted(item.isSubmitted);
            setSakhaSubmitted(item.sakha);
            break;
          default:
            break;
        }
      });

    } catch (error) {
      console.error("Error fetching Data:", error);
      setError(error?.response?.data?.message || "No Data available.");
      setLoading(false);
    }
  }, [axiosPrivate, Id]);




  useEffect(() => {
    fetchgurudakshina();
    fetchGurudakshinaFinalizationStatus();
  }, [selectedSakha]);


  const showMessage = (type, message) => {
    if (type === 'error') {
      setErrMsg(message);
      setSucssMsg(""); // clear success message
    } else if (type === 'success') {
      setSucssMsg(message);
      setErrMsg(""); // clear error message
      setShowSuccessModal(true); // Show modal

      // Auto close after 10 seconds (10000 ms)
      setTimeout(() => {
        setShowSuccessModal(false);
      }, 5000);
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      var data = JSON.stringify({
        sthan_id: Id,
        sakha: sakhaSubmitted,
      });

      const response = await axiosPrivate.post(`update-final-submissions`, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      showMessage('success', response?.data?.message);
      setShowSecondModal(false);
    } catch (err) {

      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.data?.message) {
        const errorMsg = typeof err.response.data.message === 'string'
          ? err.response.data.message
          : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
        setErrMsg(errorMsg);
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }


  };

  const indexOfLastGurudakshina = currentPage * gurudakshinaPerPage;
  const indexOfFirstGurudakshina = indexOfLastGurudakshina - gurudakshinaPerPage;
  const currentgurudakshinas = gurudakshinas.slice(indexOfFirstGurudakshina, indexOfLastGurudakshina);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(gurudakshinas.length / gurudakshinaPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>
      <section className="empbody">
        <div className="wrapperemp2">
          {/* ✅ Finalize Button with Modal trigger */}



          <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <button onClick={ClickAddGurudakshina} type="button" className="btn btn-success ms-auto newviewbtn">+ Gurudakshina</button>
            <button onClick={handleShowModal} type="button" className="btn btn-warning  newviewbtn">Finalize</button>


          </div>

          <h3>List Gurudakshina In  <span className="colorChange">{Name}</span> Sthan</h3>


          <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton>
              {/* <Modal.Title>Success</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <p>{sucssMsg}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                OK
              </Button>
            </Modal.Footer>
          </Modal>
          <Row>
            <Col md={1}></Col>
            <Col md={10}>

              <Form.Group controlId="pranthDropdown" className="mb-3">
                <Form.Label>Select Ultsavam</Form.Label>
                <Form.Control
                  as="select"
                  value={selectedSakha}
                  onChange={(e) => setSelectedSakha(e.target.value)}
                >
                  <option value="">-- Select Ultsavam --</option>
                  {sakhaList.map((sakha, index) => (
                    <option key={index} value={sakha}>{sakha}</option>
                  ))}
                </Form.Control>
              </Form.Group >
            </Col>
            <Col md={1}></Col>
          </Row>


          <div className="table-container">
            <div className="newdivst">
              {gurudakshinaFinalizationStatus && (
                <Row>
                  <Col md={3}>
                    <p>Ultsavam : <span>{gurudakshinaFinalizationStatus.sakha}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Total Amount : <span>{gurudakshinaFinalizationStatus.amount}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Submitted Date : <span>{gurudakshinaFinalizationStatus.submitted_date}</span></p>
                  </Col>
                  <Col md={3}>
                    <p>Is Submitted : <span>{gurudakshinaFinalizationStatus.isSubmitted ? "Yes" : "No"}</span></p>
                  </Col>
                </Row>
              )}
            </div>

            <table id="customers">
              <thead>
                <tr>
                  <th>Ultsavam</th>
                  <th>Shreni</th>
                  <th>Name</th>
                  <th>PAN</th>
                  <th>Mobile</th>
                  <th>Amount</th>
                  <th>Samarppan date</th>
                  <th>Options</th>
                </tr>
              </thead>
              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="8" className="text-danger text-center">
                      {typeof error === 'string' ? error : error?.msg || "An error occurred."}
                    </td>

                  </tr>
                ) : gurudakshinas.length === 0 ? (
                  <tr>
                    <td colSpan="8">No Gurudakshina available.</td>
                  </tr>
                ) : (
                  currentgurudakshinas.map(gurudakshina => (
                    <tr key={gurudakshina.id}>
                      <td>{gurudakshina.sakha}</td>
                      <td>{gurudakshina.shreni}</td>
                      <td>{gurudakshina.name}</td>
                      <td>{gurudakshina.pan}</td>
                      <td>{gurudakshina.mobile}</td>
                      <td>{gurudakshina.amount}</td>
                      <td>
                        {new Date(gurudakshina.date_of_samarppan).toLocaleString('en-IN', {
                          timeZone: 'Asia/Kolkata',
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        }).replace(/ /g, '/')}
                      </td>
                      <td>
                        <button type="button" className="btn btn-info btn-ico" onClick={() => window.open(`/view/gurudakshina/${gurudakshina.id}`, '_blank')}>
                          <i className="bx bxs-show icon"></i>
                        </button>
                        <button type="button" className="btn btn-warning btn-ico" onClick={() => window.open(`/arthiksakha/edit/gurudakshina/${gurudakshina.id}/${gurudakshina.sthan_id}`, '_blank')}>
                          <i className="bx bxs-edit icon"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="table-container">
            {totalPages > 1 && (
              <div className="pagination">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    disabled={currentPage === index + 1}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
              </div>
            )}
          </div>
        </div>
      </section>

      <Modal show={showFinalizeModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Which you want to finalize?</h6>
              <table className="table table-bordered mt-3" id="customers">
                <tbody>
                  <tr>
                    <td>Vidyarthi Samyuktha</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vidyarthi Samyuktha");
                          handleFinalize();
                        }}
                        disabled={vidyarthiSamyukthaSubmitted} // button will be disabled when this is true
                      >
                        Finalize
                      </Button>


                    </td>
                  </tr>
                  <tr>
                    <td>Vidyarthi Tharuna</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vidyarthi Tharuna");
                          handleFinalize();
                        }}
                        disabled={vidyarthiTharunaSubmitted} // button will be disabled when this is true
                      >
                        Finalize
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>Vyavasayi Tharuna</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Vyavasayi Tharuna");
                          handleFinalize();
                        }}
                        disabled={vyavasayiTharunaSubmitted} // button will be disabled when this is true
                      >
                        Finalize
                      </Button>
                    </td>
                  </tr>
                  <tr>
                    <td>Prouda</td>
                    <td>
                      <Button
                        className="tbnewbtn"
                        onClick={() => {
                          setSakhaSubmitted("Prouda");
                          handleFinalize();
                        }}
                        disabled={proudaSubmitted} // button will be disabled when this is true
                      >
                        Finalize
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </table>



              <Button className="tbnewbtncl" onClick={handleCloseModal}>Close</Button>

              <p className="newmodalheadp">ശ്രദ്ധിക്കുക!.</p>
              <p className="newmodalp">ഓരോ ശാഖയുടെയും തുക പരിശോധിച്ച് ഉറപ്പുവരുത്തിയതിനു ശേഷം മാത്രം FINALIZE ചെയ്യുക.
                FINALIZE ചെയ്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>
            </center>
          </div>
        </Modal.Body>
      </Modal>


      <Modal show={showSecondModal} onHide={handleCloseSecondModal} centered>
        {/* <Modal.Header closeButton>
    <Modal.Title>Finalize Confirmation</Modal.Title>
  </Modal.Header> */}
        <Modal.Body>
          <div className="modstyle">
            <center>
              <h6>Do you want to finalize <span className="colorChange">{sakhaSubmitted}</span>?</h6>
              <p className="newmodalp2">FINALIZE ചെയ്ത്‌തു കഴിഞ്ഞ ശാഖ യുടെ ഗുരുദക്ഷിണ ലിസ്റ്റിൽ താങ്കൾക്ക് മാറ്റം വരുത്താൻ സാധിക്കുകയില്ല.</p>

              <Button className="newbtn2" onClick={handleCloseSecondModal}>
                No
              </Button>
              <Button className="newbtn" onClick={handleSubmit}>
                Yes
              </Button>
            </center>
          </div>

        </Modal.Body>
        {/* <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseSecondModal}>
      Cancel
    </Button>
    <Button variant="success" onClick={() => {
      handleCloseSecondModal();
      handleRedirect(); // or your finalize logic
    }}>
      Confirm
    </Button>
  </Modal.Footer> */}
      </Modal>


      <TopBar />
    </>
  );
};

export default ArthiksakhaListGurudakshinaInSthan;
